import { render, staticRenderFns } from "./sbEdit.vue?vue&type=template&id=4c9d0757&"
import script from "./sbEdit.vue?vue&type=script&lang=js&"
export * from "./sbEdit.vue?vue&type=script&lang=js&"
import style0 from "./sbEdit.vue?vue&type=style&index=0&id=4c9d0757&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports